import { render, staticRenderFns } from "./ModalStats.vue?vue&type=template&id=386e847e"
import script from "./ModalStats.vue?vue&type=script&lang=js"
export * from "./ModalStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports